import { Controller } from "@hotwired/stimulus";

// Generic click-to-open tooltip-style popup, anchored to a trigger element.
// Paired with the `.tooltippy-popup` SCSS component. Closes on outside click
// or Escape, and nudges the popup to stay inside the viewport.
//
// Markup pattern:
//   <span class="tooltippy-anchor" data-controller="tooltippy">
//     <button data-action="click->tooltippy#open">Trigger</button>
//     <div class="tooltippy-popup" hidden data-tooltippy-target="popup">…</div>
//   </span>
export default class extends Controller {
  static targets = ["popup"];

  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    this.stopListening();
  }

  open(event) {
    event.preventDefault();
    event.stopPropagation();
    this.popupTarget.hidden = false;
    this.adjustPosition();
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);
  }

  close(event) {
    if (event) event.preventDefault();
    this.popupTarget.hidden = true;
    this.stopListening();
  }

  // Keeps the popup fully inside the viewport: shifts it horizontally if it
  // overflows left/right, and flips it above the trigger if it overflows the
  // bottom edge.
  adjustPosition() {
    const popup = this.popupTarget;
    const margin = 8;

    popup.style.left = "0";
    popup.style.right = "auto";
    popup.style.top = "100%";
    popup.style.bottom = "auto";

    const rect = popup.getBoundingClientRect();

    if (rect.right > window.innerWidth - margin) {
      popup.style.left = "auto";
      popup.style.right = "0";
    } else if (rect.left < margin) {
      popup.style.left = `${margin - rect.left}px`;
    }

    const rect2 = popup.getBoundingClientRect();
    if (rect2.bottom > window.innerHeight - margin) {
      popup.style.top = "auto";
      popup.style.bottom = "100%";
    }
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close();
  }

  stopListening() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
  }
}
